<template>
  <div :class="`nnform-element-container ${this.error ? `has-error`: ``}`">
    <textarea
        :name="name"
        rows="3"
        class="nnform-element area"
        :placeholder="label"
        :value="modelValue"
        @input="handler"></textarea>
    <label :class="{'nnform-element-label':true,'required':required}">{{ label }}</label>
    <div v-if="this.error" class="nnform-error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: "CheckoutArea",
  props: {
    label: String,
    required: Boolean,
    name: String,
    error: String,
    modelValue: null,
  },
  methods: {
    handler(e) {
      this.$emit("update:modelValue", e.target.value);
      this.$emit("unset");
    },
  },
}
</script>

<style scoped>

</style>